import React from 'react';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

interface Props {
	onEditClick: () => void;
}

const ManagerWorkplaceItemButtonsEdit = ({ onEditClick }: Props) => {
	return (
		<LinkButton
			onClick={onEditClick}
			title='base.shared.edit'
			theme={Theme.BLUE}
			firstUpper
		/>
	);
};

export default ManagerWorkplaceItemButtonsEdit;
